import { z } from "zod";

export const ExternalControlSchema = z.object({
  externalRef: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  idCode: z.string().nullable(),
  source: z.string(),
  linked: z.boolean(),
});

export type ExternalControl = z.infer<typeof ExternalControlSchema>;

export const ListExternalControlsResponseSchema = z.object({
  controls: z.array(ExternalControlSchema),
  source: z.string(),
  total: z.number(),
});

export type ListExternalControlsResponse = z.infer<
  typeof ListExternalControlsResponseSchema
>;

export const ExternalRefSchema = z.object({
  id: z.string().uuid(),
  externalRef: z.string(),
  externalControlsDatumId: z.number().int().nullable(),
  createdAt: z.string(),
});

export type ExternalRef = z.infer<typeof ExternalRefSchema>;
